import angular from 'angular';

// Translations
import translation from '../../../../../lib/translation';

// Load all services
import '../../../../../lib/service';

// Component
import component from './primaryClaimEditor.component';

// Dependencies
import 'angular-ui-bootstrap/src/datepickerPopup';
import 'angular-ui-bootstrap/src/datepicker';

const moduleName = 'staff.dashboardScreen.primaryClaimEditor';
let module = angular.module(moduleName, [
  translation,
  'ui.bootstrap',
  'ui.bootstrap.datetimepicker',
]);

module.component('primaryClaimEditor', component);

export default module;
